<mat-card class="card">
  <mat-card-header class="header">
    <h3 class="flex-100">
      <fa-icon icon="money-bill"></fa-icon>
      &nbsp;&nbsp; {{ 'labels.inputs.Amount Pending / Disbursed' | translate }}
      <div>
        <mat-form-field id="office" class="flex-94">
          <mat-label>{{ 'labels.inputs.Office' | translate }}</mat-label>
          <mat-select [formControl]="officeId">
            @for (office of officeData; track office) {
              <mat-option [value]="office.id">
                {{ office.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </h3>
  </mat-card-header>

  <mat-card-content>
    <!-- Structural directives like *ngIf break the canvas -->
    <div [ngStyle]="{ display: hideOutput ? 'none' : 'block' }">
      <canvas id="disbursement-pie" width="800" height="600"></canvas>
    </div>
    @if (showFallback) {
      <div class="fallback align-center-center">
        <p>{{ 'labels.text.No Data' | translate }}</p>
      </div>
    }
  </mat-card-content>
</mat-card>
